/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid2,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { DataGrid } from '@mui/x-data-grid';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import getToken from 'helpers/auth';
import moment from 'moment';
import { Download, ShareButton } from 'components/Download';
import { intervalToDuration } from 'date-fns/esm/fp';
import Swal from 'sweetalert2';

export default function DailyConsumptionReport({
  heatMap,
  setHeatMap,
  valueInfo,
  setValueInfo,
  updateMonth,
  updateYear,
  rateHorary,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openVoltage, setOpenVoltage] = useState(false);
  const [dataConsume, setDataConsume] = useState([]);
  const [dataVoltage, setDataVoltage] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showStartDatePop, setShowStartDatePop] = useState(false);
  const [showEndDatePop, setShowEndDatePop] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [chargeVoltageId, setChargeVoltageId] = useState(null);
  const [stats, setStats] = useState([]);
  const chartRef = useRef();
  const chartIntRef = useRef();

  const concentrator_id = useSelector(
    (state) => state.chargeDashboard.generalConsumes.concentrator_id
  );
  const charge = useSelector(
    (state) => state.chargeDashboard.generalConsumes.charge_info
  );
  const charge_id = charge ? charge.id : 0;

  const calculateStats = (data) => {
    if (data.length === 0) return { min: 0, max: 0, avg: 0 };
    const values = data.map((item) => item[1]);
    const min = Math.min(...values).toFixed(2);
    const max = Math.max(...values).toFixed(2);
    const avg = (
      values.reduce((sum, value) => sum + value, 0) / values.length
    ).toFixed(2);
    return { min, max, avg };
  };

  useEffect(() => {
    dispatch(voltageValidate());
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
    filter5MinRecords(startDate, endDate);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleHM = (event) => {
    const { name, checked } = event.target;
    if (name === 'fee' && checked) {
      setHeatMap({
        fee: true,
        hm: false,
      });
    } else if (name === 'hm' && checked) {
      setHeatMap({
        fee: false,
        hm: true,
      });
    }
  };

  const getColorFont = (obj) => {
    if (obj.max_kwh === 1) {
      return '#3ba400';
    } else if (obj.min_kwh === 1) {
      return '#ad1f1f';
    } else {
      return '#12161B';
    }
  };

  const generalReport = useSelector(
    (state) => state.chargeDashboard.generalReport.report
  );

  const totalPerHour = useSelector(
    (state) => state.chargeDashboard.generalReport.total_per_hour
  );

  const data = [];

  if (generalReport != undefined || generalReport != null) {
    Object.values(generalReport).forEach((element) => {
      element.forEach((element2) => {
        let obj = {
          hora: parseInt(element2.Hora),
          medicion: element2.Kwh,
          color: heatMap.fee
            ? element2.color
            : valueInfo.money
              ? element2.color_cost
              : element2.color_hm_kwh,
          alerta_consumo: element2.alerta_consumo,
          max_day: element2.max_day,
          max_month: element2.max_month,
          min_day: element2.min_day,
          min_month: element2.min_month,
          font_color: getColorFont(element2),
          border:
            element2.alerta_consumo == 1 ||
            element2.max_kwh == 1 ||
            element2.min_kwh == 1
              ? '3px solid black'
              : '1px solid rgb(126, 126, 126)',
          font_size:
            element2.alerta_consumo == 1 ||
            element2.max_kwh == 1 ||
            element2.min_kwh == 1
              ? '16px'
              : '12px',
          font_weight:
            element2.alerta_consumo == 1 ||
            element2.max_kwh == 1 ||
            element2.min_kwh == 1
              ? 'bold'
              : 'normal',
          cost_kwh: parseFloat(element2.cost_kwh).toFixed(2),
        };
        data.push(obj);
      });
    });
  }

  const calculateHourlyStatistics = () => {
    const hourlyData = Array.from({ length: 24 }, () => []);

    data.forEach((element) => {
      const hour = element.hora;
      const cost = parseFloat(element.cost_kwh);
      if (cost !== 0) {
        hourlyData[hour].push(cost);
      }
    });

    const minCosts = hourlyData.map((hourCosts) =>
      hourCosts.length ? Math.min(...hourCosts) : null
    );
    const maxCosts = hourlyData.map((hourCosts) =>
      hourCosts.length ? Math.max(...hourCosts) : null
    );
    const avgCosts = hourlyData.map((hourCosts) =>
      hourCosts.length
        ? (
            hourCosts.reduce((acc, curr) => acc + curr, 0) / hourCosts.length
          ).toFixed(2)
        : null
    );

    return {
      min: minCosts,
      max: maxCosts,
      average: avgCosts,
    };
  };

  const statistics = calculateHourlyStatistics();

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  if (totalPerHour !== undefined || generalReport != null) {
    Object.values(totalPerHour).forEach((hourData, index) => {
      let obj = data.find((d) => d.hora === index);
      if (obj) {
        obj.min = valueInfo.kwh ? hourData.min : `$${statistics.min[index]}`;
        obj.max = valueInfo.kwh ? hourData.max : `$${statistics.max[index]}`;
        obj.prom = valueInfo.kwh
          ? hourData.prom
          : formatter.format(hourData.prom_cost_kwh);
        obj.colorProm =
          valueInfo.money && heatMap.hm
            ? hourData.color_cost
            : valueInfo.kwh && heatMap.hm
              ? hourData.color_hm
              : 'white';
      }
    });
  }

  const res = data.reduce((acc, curr) => {
    if (!acc[curr.hora]) acc[curr.hora] = []; // If this type wasn't previously stored
    acc[curr.hora].push(curr);
    return acc;
  }, {});

  const thumbHorizontal = ({ style, ...props }) => {
    const finalStyle = {
      cursor: 'pointer',
      backgroundColor: 'rgba(255,0,0,.6)',
    };
    return <div style={finalStyle} {...props} />;
  };

  const handleSelectStartDate = (iniDate) => {
    setStartDate(iniDate);
    setShowStartDatePop(false);
    if (openVoltage) {
      setDataVoltage([]);
      setErrorMessage(null);
      filter5MinRecordsVoltage(iniDate, endDate);
    } else {
      setDataConsume([]);
      setErrorMessage(null);
      filter5MinRecords(iniDate, endDate);
    }
  };

  const handleSelectEndDate = (finDate) => {
    if (openVoltage) {
      setEndDate(finDate);
      setShowEndDatePop(false);
      filter5MinRecordsVoltage(startDate, finDate);
    } else {
      setEndDate(finDate);
      setShowEndDatePop(false);
      filter5MinRecords(startDate, finDate);
    }
  };

  const set5MinDates = (data, isVoltage) => {
    let idx = 0;
    let arr_days = [];
    let arrData = [];
    const hourlyData = {};
    for (idx = 0; idx < data.length; idx++) {
      const dateStr = data[idx].date.toString();
      const year = parseInt(dateStr.substring(0, 4));
      const month = parseInt(dateStr.substring(4, 6)) - 1;
      const day = parseInt(dateStr.substring(6, 8));
      const hour = parseInt(dateStr.substring(8));
      const date = new Date(year, month, day, hour);
      const dateKey = date.getTime();

      if (!hourlyData[dateKey]) {
        hourlyData[dateKey] = {
          date: date,
          total: 0,
          count: 0,
        };
      }

      arr_days = data[idx].data;
      for (let jj = 0; jj < arr_days.length; jj++) {
        const dayData = arr_days[jj];
        // hourlyData[dateKey].maxValue = Math.max(hourlyData[dateKey].maxValue, dayData.value);
        hourlyData[dateKey].total += dayData.value;
        hourlyData[dateKey].count++;
      }
    }

    for (const dateKey in hourlyData) {
      const hourlyDataPoint = hourlyData[dateKey];
      const sumValue = hourlyDataPoint.total;
      arrData.push([hourlyDataPoint.date.getTime(), sumValue]);
      // arrData.push([hourlyDataPoint.date.getTime(), hourlyDataPoint.maxValue]);
    }
    if (isVoltage) {
      setDataVoltage(arrData);
      setStats(calculateStats(arrData));
    } else {
      setDataConsume(arrData);
      setStats(calculateStats(arrData));
    }
  };

  const filter5MinRecords = (fechaIni, fechaFin) => {
    let dayDifs = getDateDiffInDays(fechaIni, fechaFin);
    if (dayDifs > 31) {
      setErrorMessage(
        '[' +
          dayDifs +
          ' ' +
          intl.formatMessage({
            id: 'app.deepview.consumption.datesRangeError.rangeTooLong',
          })
      );
      return;
    } else {
      if (dayDifs < 0) {
        setErrorMessage(
          intl.formatMessage({
            id: 'app.deepview.consumption.datesRangeError.wrongIniEnd',
          })
        );
        return;
      }

      setErrorMessage(null);
    }

    let txtIniDate = getDateAsString(fechaIni);
    let txtEndDate = getDateAsString(fechaFin);
    txtIniDate = txtIniDate + '00';
    txtEndDate = txtEndDate + '23';
    dispatch(get5MinRecords(txtIniDate, txtEndDate));
  };

  const getDateDiffInDays = (startDate, endDate) => {
    const diffTime = endDate - startDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1;
  };

  const getDateAsString = (date) => {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let strMonth = month.toString();
    if (month < 10) {
      strMonth = '0' + strMonth;
    }
    let strDay = day.toString();
    if (day < 10) {
      strDay = '0' + strDay;
    }

    let strDate = year + strMonth + strDay;
    return strDate;
  };

  const get5MinRecords = (startDate, endDate) => {
    return async () => {
      axios
        .post(
          'https://api.metimur.mx/api/charge/5minutal',
          {
            concentrator_id: concentrator_id,
            charge_id: charge_id,
            start_date: /*'2023050100'*/ startDate,
            end_date: /* '2023051023'*/ endDate,
          },
          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then((response) => {
          set5MinDates(response.data.data, false);
        })
        .catch(function (error) {
          console.log('error:' + error);
        });
    };
  };

  const voltageValidate = () => {
    return async () => {
      axios
        .post(
          'https://api.metimur.mx/api/charge/voltagevalidation',
          {
            charge_id: charge_id,
          },
          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then((response) => {
          //set5MinDates(response.data.data);
          configVoltageChage(response.data.data);
        })
        .catch(function (error) {
          console.log('error:' + error);
        });
    };
  };
  const configVoltageChage = (data) => {
    if (!data) {
      setChargeVoltageId(null);
      return;
    }
    if (data.has_voltage == 1) {
      setChargeVoltageId(data.charge_voltage);
    } else {
      setChargeVoltageId(null);
    }
  };
  const filter5MinRecordsVoltage = (fechaIni, fechaFin) => {
    let dayDifs = getDateDiffInDays(fechaIni, fechaFin);
    if (dayDifs > 31) {
      setErrorMessage(
        '[' +
          dayDifs +
          ' ' +
          intl.formatMessage({
            id: 'app.deepview.consumption.datesRangeError.rangeTooLong',
          })
      );
      return;
    } else {
      if (dayDifs < 0) {
        setErrorMessage(
          intl.formatMessage({
            id: 'app.deepview.consumption.datesRangeError.wrongIniEnd',
          })
        );
        return;
      }
      setErrorMessage(null);
    }
    let txtIniDate = getDateAsString(fechaIni);
    let txtEndDate = getDateAsString(fechaFin);
    txtIniDate = txtIniDate + '00';
    txtEndDate = txtEndDate + '23';
    dispatch(get5MinRecordsVoltage(txtIniDate, txtEndDate));
  };

  const get5MinRecordsVoltage = (startDate, endDate) => {
    return async () => {
      axios
        .post(
          'https://api.metimur.mx/api/charge/5minutalvoltage',
          {
            concentrator_id: concentrator_id,
            charge_id: chargeVoltageId,
            start_date: /*'2023050100'*/ startDate,
            end_date: /* '2023051023'*/ endDate,
          },
          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then((response) => {
          set5MinDates(response.data.data, true);
        })
        .catch(function (error) {
          console.log('error:' + error);
        });
    };
  };

  const handleValue = (event) => {
    const { name, checked } = event.target;
    if (name === 'kwh' && checked) {
      setValueInfo({
        kwh: true,
        money: false,
      });
    } else if (name === 'money' && checked) {
      Swal.fire({
        icon: 'warning',
        title: intl.formatMessage({ id: 'app.barmenu.attention' }),
        text: intl.formatMessage({ id: 'app.barmenu.message' }),
      });
      setValueInfo({
        kwh: false,
        money: true,
      });
    }
  };

  Highcharts.setOptions({
    lang: {
      months: [
        intl.formatMessage({ id: 'app.months.jan' }),
        intl.formatMessage({ id: 'app.months.feb' }),
        intl.formatMessage({ id: 'app.months.mar' }),
        intl.formatMessage({ id: 'app.months.apr' }),
        intl.formatMessage({ id: 'app.months.may' }),
        intl.formatMessage({ id: 'app.months.jun' }),
        intl.formatMessage({ id: 'app.months.jul' }),
        intl.formatMessage({ id: 'app.months.ago' }),
        intl.formatMessage({ id: 'app.months.sep' }),
        intl.formatMessage({ id: 'app.months.oct' }),
        intl.formatMessage({ id: 'app.months.nov' }),
        intl.formatMessage({ id: 'app.months.dec' }),
      ],
      weekdays: [
        intl.formatMessage({ id: 'app.daysOfWeek.sun' }),
        intl.formatMessage({ id: 'app.daysOfWeek.mon' }),
        intl.formatMessage({ id: 'app.daysOfWeek.tue' }),
        intl.formatMessage({ id: 'app.daysOfWeek.wed' }),
        intl.formatMessage({ id: 'app.daysOfWeek.thu' }),
        intl.formatMessage({ id: 'app.daysOfWeek.fri' }),
        intl.formatMessage({ id: 'app.daysOfWeek.sat' }),
      ],
      shortMonths: [
        intl.formatMessage({ id: 'app.monthsShort.jan' }),
        intl.formatMessage({ id: 'app.monthsShort.feb' }),
        intl.formatMessage({ id: 'app.monthsShort.mar' }),
        intl.formatMessage({ id: 'app.monthsShort.apr' }),
        intl.formatMessage({ id: 'app.monthsShort.may' }),
        intl.formatMessage({ id: 'app.monthsShort.jun' }),
        intl.formatMessage({ id: 'app.monthsShort.jul' }),
        intl.formatMessage({ id: 'app.monthsShort.aug' }),
        intl.formatMessage({ id: 'app.monthsShort.sep' }),
        intl.formatMessage({ id: 'app.monthsShort.oct' }),
        intl.formatMessage({ id: 'app.monthsShort.nov' }),
        intl.formatMessage({ id: 'app.monthsShort.dec' }),
      ],
      shortWeekdays: [
        intl.formatMessage({ id: 'app.daysOfWeekShort.sun' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.mon' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.tue' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.wed' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.thu' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.fri' }),
        intl.formatMessage({ id: 'app.daysOfWeekShort.sat' }),
      ],
    },
  });

  const chipIndicator = () => {
    if (heatMap.fee) {
      return (
        <Grid2 display="flex" justifyContent="space-between" gap={2}>
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipBase',
            })}
            style={{
              backgroundColor: '#bfe5bf',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipIntermed',
            })}
            style={{
              backgroundColor: '#f2e5bf',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipTip',
            })}
            style={{
              backgroundColor: '#f2bfbf',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
        </Grid2>
      );
    } else {
      return (
        <Grid2 display="flex" justifyContent="space-between" gap={2}>
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipBaja',
            })}
            style={{
              backgroundColor: '#E37878',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipBajaMed',
            })}
            style={{
              backgroundColor: '#E3A478',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipMedia',
            })}
            style={{
              backgroundColor: '#E3E378',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipMediaAlt',
            })}
            style={{
              backgroundColor: '#A4E378',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
          <Chip
            label={intl.formatMessage({
              id: 'app.charge.board.dailyRepDemand.chipAlta',
            })}
            style={{
              backgroundColor: '#78E378',
              fontSize: '.95rem',
              fontWeight: 500,
            }}
          />
        </Grid2>
      );
    }
  };

  const [days, setDays] = useState([]);
  const localeNav = useSelector((state) => state.prefs.locale);

  useEffect(() => {
    const daysInMonth = updateYear
      ? moment(`${updateYear}${updateMonth}`).daysInMonth()
      : moment().daysInMonth();
    const currentMonth = moment().month();
    const currentYear = moment().year();
    const daysArray = [];
    moment.locale(localeNav);
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment({
        year: updateYear ? updateYear : currentYear,
        month: updateMonth ? updateMonth - 1 : currentMonth,
        day: i,
      });
      daysArray.push({
        day: i,
        weekday: date.format('ddd'),
      });
    }

    setDays(daysArray);
  }, [localeNav, updateMonth, updateYear]);

  const options = {
    lang: {
      months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      weekdays: [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
      ],
      shortMonths: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      shortWeekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
    turboThreshold: 0,
    time: {
      useUTC: false,
      timezone: 'America/Mexico_City',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: 'Reporte de Generación',
    },
    xAxis: {
      type: 'datetime',
      crosshair: true,

      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%a %e. %b',
        week: '%e. %b',
        month: "%b '%y",
        year: '%Y',
      },
    },
    yAxis: [
      {
        title: {
          text: 'kWh',
        },
        labels: {
          format: '{value}kWh',
        },
      },
    ],
    rangeSelector: {
      enabled: true,
      selected: 4,
    },
    tooltip: {
      positioner: function (labelWidth, labelHeight, point) {
        const chart = this.chart;
        // const position = point.plotY + chart.plotTop - 100; // Ajusta según tus necesidades
        // return { x: point.plotX + chart.plotLeft, y: position };
        let x = point.plotX + chart.plotLeft;
        let y = point.plotY + chart.plotTop - labelHeight - 10;

        // Si esta muy cerca del borde superior, colocar abajo del punto
        if (y < 10) {
          y = point.plotY + chart.plotTop + 10;
        }

        // Ajuste para que no se desborde por la derecha
        if (x + labelWidth > chart.chartWidth) {
          x = chart.chartWidth - labelWidth - 10;
        }

        // Ajuste para que no se desborde por la parte inferior
        if (y + labelHeight > chart.chartHeight) {
          y = chart.chartHeight - labelHeight - 10;
        }

        return { x, y };
      },

      formatter: function () {
        const date = new Date(this.x);
        const options = {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          weekday: 'long',
        };

        const formattedDate = date
          .toLocaleString(intl.formatMessage({ id: 'app.locale' }), options)
          .replace(',', ''); // replace the comma with an empty string

        return (
          '<b>' +
          this.series.name +
          '</b><br/>' +
          formattedDate +
          //new Date(this.x).toString()
          '<br/>' +
          Highcharts.numberFormat(this.y, 2) +
          ' kWh'
        );
      },
    },
    series: [
      {
        name: 'Generación',
        turboThreshold: 0,
        data: dataConsume,
        id: 'dataseries',

        tooltip: {
          valueDecimals: 4,
        },
      },
    ],
    legend: {
      itemStyle: {
        fontSize: '16px',
        fontWeight: 'bold',
      },
    },
  };

  const columns = [
    {
      headerName: intl.formatMessage({ id: 'app.metersCards.card.voltageMin' }),
      field: 'min',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      fontWeight: 'bold',
      width: 100,
      resizable: false,
      sortable: false,
      headerClassName: 'header-bold',
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#8CBA42',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({ id: 'app.metersCards.card.voltageMax' }),
      field: 'max',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      width: 100,
      resizable: false,
      sortable: false,
      headerClassName: 'header-bold',
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#D64539',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({ id: 'app.metersCards.card.voltageAve' }),
      field: 'avg',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      width: 100,
      resizable: false,
      sortable: false,
      headerClassName: 'header-bold',
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#EAAB36',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
  ];

  const rows = [
    {
      id: 1, // Un id único para cada fila
      min: stats?.min || 0,
      max: stats?.max || 0,
      avg: stats?.avg || 0,
    },
  ];

  const handleCapture = async (ref) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    const formatName = (name) => {
      return name.toLocaleLowerCase().split(' ').join('-');
    };

    // Esperar un momento para que React actualice el estado antes de la captura
    await new Promise((resolve) => setTimeout(resolve, 100));

    if (ref === 'ext') {
      if (chartRef.current) {
        const canvas = await html2canvas(chartRef.current, { scale: 2 });
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download =
          formatName(
            intl.formatMessage({
              id: 'app.chargeSolar.board.dailyRepConsump.title',
            })
          ) + '.png';
        link.click();

        Toast.fire({
          icon: 'success',
          title: 'Se ha descargado la imagen',
        });
      } else {
        Toast.fire({
          icon: 'error',
          title: 'No se ha podido descargar la imagen',
        });
      }
    } else {
      if (chartIntRef.current) {
        const canvas = await html2canvas(chartIntRef.current, { scale: 2 });
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download =
          formatName(
            intl.formatMessage({
              id: 'app.chargeSolar.board.analysisGeneration.title',
            })
          ) + '.png';
        link.click();

        Toast.fire({
          icon: 'success',
          title: 'Se ha descargado la imagen',
        });
      } else {
        Toast.fire({
          icon: 'error',
          title: 'No se ha podido descargar la imagen',
        });
      }
    }
  };

  return (
    <Paper sx={{ p: 2, overflowX: 'hidden', overflowY: 'auto' }}>
      <Grid2
        size={12}
        container={true}
        width="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        <Chip
          label={
            valueInfo.kwh
              ? intl.formatMessage({
                  id: 'app.chargeSolar.board.dailyRepConsump.title',
                })
              : intl.formatMessage({
                  id: 'app.chargeSolar.board.dailyRepConsump.titleCost',
                })
          }
          sx={{
            fontWeight: 700,
            backgroundColor: '#730065',
            fontSize: '16px',
            color: 'white',
          }}
        />
        <Grid2 item>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={valueInfo.kwh}
                  onChange={handleValue}
                  name="kwh"
                />
              }
              label={intl.formatMessage({ id: 'app.barmenu.kwh' })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={valueInfo.money}
                  onChange={handleValue}
                  name="money"
                />
              }
              label={intl.formatMessage({ id: 'app.barmenu.tariff' })}
            />
          </FormGroup>
        </Grid2>
        {rateHorary === 1 && (
          <Grid2>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={heatMap.fee}
                    onChange={handleHM}
                    name="fee"
                  />
                }
                label={intl.formatMessage({
                  id: 'app.chargesCards.card.hourlyRate',
                })}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={heatMap.hm}
                    onChange={handleHM}
                    name="hm"
                  />
                }
                label={intl.formatMessage({ id: 'app.barmenu.headMap' })}
              />
            </FormGroup>
          </Grid2>
        )}
        {chipIndicator()}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          <Button
            color="secondary"
            onClick={handleClickOpen}
            variant="contained"
          >
            {intl.formatMessage({
              id: 'app.chargeSolar.board.analysisGeneration.title',
            })}
          </Button>
          <Download
            itemRef={chartRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.analysisGeneration.title',
            })}
          />
          <ShareButton
            itemRef={chartRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.analysisGeneration.title',
            })}
          />
        </Box>
      </Grid2>
      <Box sx={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
        <Table size="small" sx={{ width: '100%', pb: 3 }} ref={chartRef}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  position: 'sticky',
                  left: '0',
                  background: 'white',
                  zIndex: 1,
                }}
              >
                {intl.formatMessage({
                  id: 'app.charge.board.dailyRepDemand.hourLab',
                })}
              </TableCell>
              {days.map((day, index) => (
                <TableCell key={index} sx={{ textAlign: 'center' }}>
                  {day.day}
                  <br />
                  {day.weekday.charAt(0).toUpperCase() +
                    day.weekday.slice(1, 3)}
                </TableCell>
              ))}
              <TableCell sx={{ borderLeft: '1px solid #7e7e7e' }}>
                {intl.formatMessage({
                  id: 'app.charge.board.dailyRepConsump.hourLab',
                })}
              </TableCell>
              <TableCell sx={{ borderLeft: '1px solid #7e7e7e' }}>
                {intl.formatMessage({
                  id: 'app.charge.board.totPerDay.min',
                })}
              </TableCell>
              <TableCell>
                {intl.formatMessage({
                  id: 'app.charge.board.totPerDay.max',
                })}
              </TableCell>
              <TableCell sx={{ borderLeft: '1px solid #7e7e7e' }}>
                {intl.formatMessage({
                  id: 'app.charge.board.totPerDay.avrg',
                })}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody sx={{ padding: '0 !important' }}>
            {Object.values(res)
              .sort((a, b) => a[0].hora - b[0].hora)
              .map((row, index) => (
                <TableRow sx={{ height: '0px' }} key={index}>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      position: 'sticky',
                      left: '0',
                      background: 'white',
                      zIndex: 1,
                    }}
                  >
                    {row[0].hora >= 10 ? row[0].hora : '0' + row[0].hora}:00
                  </TableCell>
                  {row.map((row, index) => (
                    <TableCell
                      component="th"
                      scope="row"
                      key={index}
                      sx={{
                        padding: '10px 13px',
                        backgroundColor: row.color,
                        fontWeight: row.font_weight,
                        color: row.font_color,
                        border: row.border,
                        fontSize: row.font_size,
                        textAlign: 'center',
                      }}
                    >
                      {valueInfo.kwh ? row.medicion : `$${row.cost_kwh}`}
                    </TableCell>
                  ))}
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ borderRight: '1px solid #7e7e7e' }}
                  >
                    {row[0].hora >= 10 ? row[0].hora : '0' + row[0].hora}:00
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row[0].min}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      borderLeft: '1px solid #7e7e7e',
                      borderLeftStyle: 'dashed',
                    }}
                  >
                    {row[0].max}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      borderLeft: '1px solid #7e7e7e',
                      backgroundColor: row[0].colorProm,
                    }}
                  >
                    {row[0].prom}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
      <Dialog fullWidth={true} maxWidth="lg" onClose={handleClose} open={open}>
        <DialogTitle
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Chip
            label={intl.formatMessage({
              id: 'app.chargeSolar.board.analysisGeneration.title',
            })}
            sx={{
              fontWeight: 700,
              backgroundColor: '#730065',
              fontSize: '16px',
              color: 'white',
              mb: 2,
            }}
          />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
          >
            <Download
              itemRef={chartIntRef}
              name={intl.formatMessage({
                id: 'app.chargeSolar.board.analysisGeneration.title',
              })}
            />
            <ShareButton
              itemRef={chartIntRef}
              name={intl.formatMessage({
                id: 'app.chargeSolar.board.analysisGeneration.title',
              })}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <Typography sx={{ color: 'red' }} variant="h5">
              {errorMessage}
            </Typography>
            <Typography variant="h5">
              {' '}
              {intl.formatMessage({
                id: 'app.deepview.consumption.datesMsg',
              })}{' '}
            </Typography>
            <Grid2 pt={3} display="flex" justifyContent="space-between">
              <Grid2 display="flex" flexDirection="row" gap={5}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Fecha de inicio"
                    format="dd/MM/yyyy"
                    value={startDate}
                    onChange={(date) => handleSelectStartDate(date)}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Fecha de fin"
                    format="dd/MM/yyyy"
                    value={endDate}
                    onChange={(date) => {
                      setEndDate(date);
                      handleSelectEndDate(date);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                  />
                </LocalizationProvider>
              </Grid2>
            </Grid2>
          </DialogContentText>
          <Box ref={chartIntRef}>
            <Paper sx={{ mt: 3 }}>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </Paper>
            <Grid2
              spacing={3}
              mt={3}
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              width="100%"
            >
              <Chip
                label="Generación (kWh)"
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#730065',
                  fontSize: '16px',
                  color: 'white',
                  mb: 2,
                }}
              />
              <DataGrid
                columns={columns}
                rows={rows}
                disableSelectionOnClick={true}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSelector={true}
                disableSorting={true}
                hideFooter={true}
                sx={{
                  boxShadow: 3,
                  borderRadius: 1,
                  width: '50%',
                  '& .MuiDataGrid-row': {
                    fontSize: 15,
                    padding: 0,
                  },
                  '& .MuiDataGrid-cell': {
                    padding: '1px 0.5px',
                  },
                  '& .MuiDataGrid-columnHeaderTitleContainer': {
                    textAlign: 'center',
                    padding: '0',
                    fontSize: '0.9em',
                    fontWeight: '800',
                    minWidth: '25%',
                  },
                  '& .header-bold': {
                    fontSize: '1.2em',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  },
                }}
              />
            </Grid2>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            onClick={handleClose}
            sx={{ marginBottom: '10px', marginRight: '15px' }}
            variant="contained"
          >
            {intl.formatMessage({ id: 'app.deepview.consumption.btnCancel' })}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
